// extracted by mini-css-extract-plugin
module.exports = {"hidden":"hidden___84jgo","block":"block___GWy08","loader":"loader___U2Wla","noMatch":"noMatch___3yzRr","setManual":"setManual___bohtM","school":"school___lg87w"};